import { Component, OnInit } from '@angular/core';
import { BizService } from './services/biz.service';
import { SecurityService } from './services/security.service';
import { TokenUpdaterService } from "./services/token-updater-service";
import { UtilityService } from "./services/utility.service";
import { MenuService } from "./services/menu-service";
import { LanguageService } from './services/language.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})

export class AppComponent implements OnInit {
  UserAuthenticateStatus = false;

  constructor(private utility: UtilityService,
              private bizService: BizService,
              private securityService: SecurityService,
              private tokenUpdateService: TokenUpdaterService,
              private menuService: MenuService,
              private languageService: LanguageService) {
    this.languageService.init();
  }

  ngOnInit(): void {
    this.tokenUpdateService.startTokenRefresh();
    this.menuService.SetActiveMenuName('Home');

    this.UserAuthenticateStatus = this.bizService.IsUserAuthenticated();
    if(this.UserAuthenticateStatus)
    {
      this.RefreshUserAccessPermission();
    }

    this.securityService.loginChangedEventEmitter.subscribe(() => {
      this.UserAuthenticateStatus = this.bizService.IsUserAuthenticated();
      this.RefreshUserAccessPermission();
    });
  }

  RefreshUserAccessPermission()
  {
    const token = this.utility.GetSecurityToken();
    if(!token || token == '')
    {
      return; // User is not logged in
    }

    this.bizService.LoadUserAccessPermissions();
  }

  IsUserAuthenticated() : boolean
  {
    return this.UserAuthenticateStatus;
  }

  PasswordIsTemporary() : boolean
  {
    return this.utility.GetPasswordIsTemporary();
  }
}
